export const CONSOLE_HELP_PAGES = [
  "announcements", "schedule", "teams", "players", "invitations", "files",
  "forms", "member-subscriptions", "member-payments", "club-billing", "account-settings",
].map(pageKey => ({ pageKey, labelKey: `help_section_${pageKey.replace(/-/g, "_")}` }));

export function normalizeConsoleHelpUrl(value) {
  if (typeof value !== "string" || value.length > 2048) return null;
  const trimmed = value.trim();
  // Validate the original path before URL can normalize dot segments or :443.
  // Greek collection slugs may be pasted as Unicode or percent-encoded text.
  const match = /^https:\/\/(help\.playerdex\.app|intercom\.help)(\/[^?#]*)$/.exec(trimmed);
  if (!match || /[\s\\\u0000-\u001f\u007f]/u.test(trimmed) || /%2f|%5c/i.test(match[2])) return null;
  try {
    const path = decodeURIComponent(match[2]);
    const prefix = match[1] === "intercom.help" ? "/playerdex" : "";
    const collectionPath = new RegExp(`^${prefix}/(?:el|en)/collections/[1-9][0-9]*(?:-[\\p{L}\\p{M}\\p{N}_-]+)?/?$`, "u");
    if (!collectionPath.test(path)) return null;
    const normalized = new URL(trimmed).href;
    return normalized.length <= 2048 ? normalized : null;
  } catch (_) {
    return null;
  }
}

export function getConsoleHelpUrl(configuration, pageKey, language) {
  const field = language === "gr" || language === "el" ? "elUrl" : language === "en" ? "enUrl" : null;
  if (!field) return null;
  const link = configuration?.links?.find(row => row.pageKey === pageKey);
  return link?.enabled ? normalizeConsoleHelpUrl(link[field]) : null;
}

export function createConsoleHelpDraft(configuration) {
  return CONSOLE_HELP_PAGES.map(({ pageKey }) => {
    const saved = configuration?.links?.find(row => row.pageKey === pageKey);
    return { pageKey, enabled: Boolean(saved?.enabled), elUrl: saved?.elUrl || "", enUrl: saved?.enUrl || "" };
  });
}

export function hasInvalidConsoleHelpDraft(links) {
  return links.some(row => [row.elUrl, row.enUrl].some(url => url.trim() && !normalizeConsoleHelpUrl(url)) ||
    (row.enabled && !row.elUrl.trim() && !row.enUrl.trim()));
}
